import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[multiEmailValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MultiEmailValidatorDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class MultiEmailValidatorDirective implements Validator {
    @Input('multiEmailValidator') emailPattern: string | RegExp;

    validate (control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) {
            return null;
        }
        const emails = value.split(',').map((e: string) => e.trim()).filter(Boolean);
        const regex = typeof this.emailPattern === 'string' ? new RegExp(this.emailPattern) : this.emailPattern;
        const invalid = emails.some((email: string) => !regex.test(email));
        return invalid ? { multiEmail: true } : null;
    }
}
